import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  postAdminUtil,
} from '../api/adminAPI';

export interface AdminState {
  status: 'idle' | 'loading' | 'failed';
  error: any;
}

const initialState: AdminState = {
  status: 'idle',
  error: null,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
const postAdminUtilAsync = createAsyncThunk(
  'admin/getCurrentFamilies',
  async (postAdminUtilData: {job: string, data: any, onSuccess?: any, onError?: any}, { rejectWithValue }) => {
    try {
      const response: any = await postAdminUtil(postAdminUtilData);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    } catch (err: any) {
      return rejectWithValue({
        name: err.name,
        message: err.message,
        stack: err.stack,
      });
    }
  },
);

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(postAdminUtilAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postAdminUtilAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.error = null;
      })
      .addCase(postAdminUtilAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
  },
});

export default adminSlice.reducer;

export {
  postAdminUtilAsync,
};